import { useFormContext } from "react-hook-form";

import { Card, CardContent, CardTitle } from "@/components/ui/card";
import { TextInput } from "@/components/ui/textInput";

import type { QuoteFormSchema } from "../../lib/schemas/createUpdateQuoteSchema";

export default function ContactInfo() {
  const {
    register,
    formState: { errors },
  } = useFormContext<QuoteFormSchema>();
  return (
    <Card className="p-10">
      <CardTitle>Contact Info</CardTitle>
      <CardContent className="p-0 pt-10 flex flex-col md:flex-row gap-4">
        {/* Quote Name */}
        <div className="flex-1">
          <label htmlFor="name" className="block text-sm font-medium text-gray-700">
            Quote Name
          </label>
          <TextInput id="name" type="text" {...register("contactInfo.name")} placeholder="Quote Name" />
          {errors.contactInfo?.name && <p className="mt-1 text-sm text-red-500">{errors.contactInfo.name.message}</p>}
        </div>

        {/* Quote Contact Email */}
        <div className="flex-1">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700">
            Quote Contact Email
          </label>
          <TextInput id="email" type="email" {...register("contactInfo.email")} placeholder="Quote Contact Email" />
          {errors.contactInfo?.email && <p className="mt-1 text-sm text-red-500">{errors.contactInfo.email.message}</p>}
        </div>
        {/* Quote Contact Email */}
        <div className="flex-1">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700">
            Salesman Email
          </label>
          <TextInput id="email" type="email" {...register("contactInfo.salesman")} placeholder="Salesman Email" />
          {errors.contactInfo?.salesman && (
            <p className="mt-1 text-sm text-red-500">{errors.contactInfo.salesman.message}</p>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
